
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import SelectBase from '@/components/atoms/SelectBase.vue'
import { SelectItem } from '@/models/SelectItem'

/**
 * セレクト部品(スクエア)
 */
@Component({
  components: {
    SelectBase,
  },
})
export default class SquareSelect extends Vue {
  /** セレクト基底部品 */
  @Ref()
  selectBase!: SelectBase

  /** オプション情報 */
  @Prop()
  private options!: SelectItem[]

  /** オプションの初期選択値 */
  @Prop()
  private optionDefault?: string | undefined

  /** disabled制御 */
  @Prop()
  private disabled?: boolean

  /**
   * 選択中の値
   *
   * @returns 選択中のオプションコード
   */
  public selectedValue(): string {
    return this.selectBase.selectedValue
  }

  /**
   * 現在の選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentValue(value: string): void {
    this.selectBase.setCurrentValue(value)
  }

  /**
   * チェンジイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private changeEvent(event: Event): void {
    this.$emit('change', event)
  }
}
